import React, { Fragment, useState, useEffect } from "react";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import {
    Typography,
    TextField,
    Button,
    Box,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    List,
    ListItem,
    ListItemText
} from "@mui/material";
import { Icon } from "@progress/kendo-react-common";
import { DateRangePicker } from "@progress/kendo-react-dateinputs";
import ErrorBoundary from "../../ErrorBoundry";
import { advanceSearchDashboard, gg1ReportDownload } from "../../_helper/services/advanceSearchv2";

const VoeReport = () => {
    const getTableName = () => dateMode === 'week' ? 'fn_WeeklyVOEReport' : 'fn_DailyVOEReport';

    // --- Component State ---
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [singleDate, setSingleDate] = useState(null);
    const [dateInput, setDateInput] = useState('');
    const [dateMode, setDateMode] = useState('week'); // 'day' or 'week'
    const [isSearched, setIsSearched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [summaryData, setSummaryData] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [detailData, setDetailData] = useState([]);
    const [selectedPeriod, setSelectedPeriod] = useState('');
    const [isDetailLoading, setIsDetailLoading] = useState(false);

    // --- Department State ---
    const [selectedDepartment, setSelectedDepartment] = useState(null);

    // --- Nature of Action State ---
    const [natureOfActionList, setNatureOfActionList] = useState([]);
    const [selectedNatureCodes, setSelectedNatureCodes] = useState([]);
    const [natureCodeSearchTerm, setNatureCodeSearchTerm] = useState("");


    const handleSearch = async () => {
        if (dateMode === 'week' && (!dateRange.start || !dateRange.end)) {
            alert("Please select a valid start and end date.");
            return;
        }
        if (dateMode === 'day' && !singleDate) {
            alert("Please select a valid date.");
            return;
        }
        setIsSearched(true);
        setIsLoading(true);
        setSummaryData([]);

        const tableName = getTableName();
        let searchParamsList;

        if (dateMode === 'week') {
            searchParamsList = [
                {
                    columnName: "StartWeekDate_p",
                    value: formatDate(dateRange.start),
                    operator: "=",
                    dataType: "VARCHAR(MAX)",
                },
                {
                    columnName: "EndWeekDate_p",
                    value: formatDate(dateRange.end),
                    operator: "=",
                    dataType: "VARCHAR(MAX)",
                }
            ];
        } else {
            searchParamsList = [
                {
                    columnName: "RequestDates",
                    value: formatDate(singleDate),
                    operator: "=",
                    dataType: "VARCHAR(MAX)",
                }
            ];
        }

        if (selectedDepartment && selectedDepartment.Dept_Code) {
            searchParamsList.push({
                columnName: "DepartmentID",
                value: selectedDepartment.Dept_Code,
                operator: "=",
                dataType: "VARCHAR(50)",
            });
        }

        const payload = {
            tableName: tableName,
            searchParams: JSON.stringify(searchParamsList),
            columns: "*",
            pageNumber: 1,
            pageSize: 10000,
            sortData: "",
            additionalWhere: "",
            location: "global",
            id: tableName,
        };
        try {
            const response = await advanceSearchDashboard(payload, tableName);
            setSummaryData(response?.results || []);
        } catch (error) {
            console.error("Failed to fetch status time summary:", error);
            alert("An error occurred while fetching the report.");
        } finally {
            setIsLoading(false);
        }
    };

    const buildSearchParams = () => {
        let searchParamsList;

        if (dateMode === 'week') {
            searchParamsList = [
                {
                    columnName: "StartWeekDate_p",
                    value: formatDate(dateRange.start),
                    operator: "=",
                    dataType: "VARCHAR(MAX)",
                },
                {
                    columnName: "EndWeekDate_p",
                    value: formatDate(dateRange.end),
                    operator: "=",
                    dataType: "VARCHAR(MAX)",
                }
            ];
        } else {
            searchParamsList = [
                {
                    columnName: "RequestDates",
                    value: formatDate(singleDate),
                    operator: "=",
                    dataType: "VARCHAR(50)",
                }
            ];
        }
        return searchParamsList;
    };


    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    };

    const formatDateISO = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toISOString().split('.')[0];
    };

    // --- Function to format numbers to 2 decimal places ---
    const formatNumber = (num) => {
        const number = parseFloat(num);
        if (isNaN(number)) {
            return num; // Return original value if not a valid number
        }
        return number.toFixed(2);
    };

    const handleCountClick = async (row) => {
        console.log(row, 'rowe')
        const period = dateMode === 'week' ? `${row.WeekStartDate} - ${row.WeekEndDate}` : row.RequestDates;
        setSelectedPeriod(period);
        setShowDetailModal(true);
        setIsDetailLoading(true);
        setDetailData([]);

        // Fetch detailed VOE list
        const detailTableName = dateMode === 'week' ? 'fn_WeeklyVOEReportwithemployeename' : 'fn_DailyVOEReportwithemployeename';
        let searchParams;

        if (dateMode === 'week') {
            searchParams = [
                {
                    columnName: "StartWeekDate_p",
                    value: row.WeekStartDate,
                    operator: "=",
                    dataType: "VARCHAR(MAX)",
                },
                {
                    columnName: "EndWeekDate_p",
                    value: row.WeekEndDate,
                    operator: "=",
                    dataType: "VARCHAR(MAX)",
                }
            ];
        } else {
            searchParams = [
                {
                    columnName: "RequestDates",
                    value: row.RequestDates,
                    operator: "=",
                    dataType: "VARCHAR(MAX)",
                }
            ];
        }
        console.log(searchParams, 'searchParamsX')
        const payload = {
            tableName: detailTableName,
            searchParams: JSON.stringify(searchParams),
            columns: "*",
            pageNumber: 1,
            pageSize: 10000,
            sortData: "EmployeeName ASC",
            additionalWhere: "",
            location: "global",
            id: detailTableName,
        };

        try {
            const response = await advanceSearchDashboard(payload, detailTableName);
            const sortedData = (response?.results || []).sort((a, b) =>
                a.EmployeeName?.localeCompare(b.EmployeeName)
            );
            setDetailData(sortedData);
        } catch (error) {
            console.error("Failed to fetch VOE details:", error);
            setDetailData([]);
        } finally {
            setIsDetailLoading(false);
        }
    };

    // --- List of headers that contain numeric data ---
    const numericHeaders = [
        "TotalDays",
        "AverageDays",
        "MedianDays",
        "TotalMinutes",
        "AverageMinutes",
        "MedianMinutes",
        "WeeklyVOERequests",
        "DailyVOERequests",
    ];

    const excludedHeaders = [
        "DepartmentID",
        "NatureCodes",
        "TotalMinutes",
        "AverageMinutes",
        "MedianMinutes",
        "StartWeekDate_p",
        "EndWeekDate_p",
        "RequestDates",
    ];
    const tableHeaders =
        summaryData.length > 0
            ? Object.keys(summaryData[0]).filter(
                (header) => !excludedHeaders.includes(header)
            )
            : [];

    const buildHeaderContentString = () => {
        const filterDescriptions = [];

        if (dateRange.start && dateRange.end) {
            filterDescriptions.push(
                `Date Range: ${formatDate(dateRange.start)} - ${formatDate(
                    dateRange.end
                )}`
            );
        }

        if (selectedDepartment && selectedDepartment.DepartmentName) {
            filterDescriptions.push(`Department: ${selectedDepartment.DepartmentName}`);
        }

        if (selectedNatureCodes.length > 0) {
            const selectedNames = natureOfActionList
                .filter((item) => selectedNatureCodes.includes(item.NATURE_CODE))
                .map((item) => item.NATURE_TITLE.trim());

            if (selectedNames.length > 0) {
                filterDescriptions.push(`Nature of Action: ${selectedNames.join(", ")}`);
            }
        }

        return filterDescriptions.join("  |  ");
    };

    const handleDownload = async () => {
        setIsDownloading(true);
        const tableName = getTableName();
        const payload = {
            tableName: tableName,
            searchParams: JSON.stringify(buildSearchParams()),
            columns: `${tableHeaders.join(",")}`,
            pageNumber: 1,
            pageSize: 10000,
            sortData: "",
            additionalWhere: "",
            location: "global",
            id: tableName,
            fileExtension: "pdf",
            isOJA: false,
            header: "LeaveReport",
            headerContent: `<div style="margin-bottom: 10px;">${buildHeaderContentString()}</div>`,
        };

        try {
            const response = await gg1ReportDownload(payload);
            const filename = `report_${new Date().getTime()}.pdf`;
            const blob = await response.data;
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Failed to download report:", error);
            alert("An error occurred while downloading the report.");
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <ErrorBoundary>
            <Fragment>
                <Container fluid={true}>
                    <Row className="bg-primary rounded py-3 mb-3">
                        <Typography variant="h5">
                            <Icon style={{ fontSize: "25px", margin: "10px" }} name="clock" />
                            VOE Report
                        </Typography>
                    </Row>
                    <Row>
                        <Col sm="12" className="page-content">
                            <Card>
                                <CardBody>
                                    <Box sx={{ p: 2 }}>
                                        <Typography variant="h6" gutterBottom fontWeight="bold">
                                            Report Parameters
                                        </Typography>
                                        <Box sx={{ mb: 2 }}>
                                            <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                                                <Button
                                                    variant={dateMode === 'day' ? 'contained' : 'outlined'}
                                                    onClick={() => setDateMode('day')}
                                                    size="small"
                                                >
                                                    By Day
                                                </Button>
                                                <Button
                                                    variant={dateMode === 'week' ? 'contained' : 'outlined'}
                                                    onClick={() => setDateMode('week')}
                                                    size="small"
                                                >
                                                    By Week
                                                </Button>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: 2,
                                                    alignItems: "center",
                                                    mb: 2,
                                                }}
                                            >
                                                {dateMode === 'week' ? (
                                                    <DateRangePicker
                                                        value={dateRange}
                                                        onChange={(e) => setDateRange(e.value)}
                                                    />
                                                ) : (
                                                    <TextField
                                                        label="Select Date"
                                                        placeholder="mm/dd/yyyy"
                                                        value={dateInput}
                                                        onChange={(e) => {
                                                            let value = e.target.value.replace(/\D/g, '');
                                                            if (value.length >= 2) value = value.substring(0, 2) + '/' + value.substring(2);
                                                            if (value.length >= 5) value = value.substring(0, 5) + '/' + value.substring(5, 9);
                                                            setDateInput(value);
                                                            if (value.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                                                                const [month, day, year] = value.split('/');
                                                                setSingleDate(new Date(year, month - 1, day));
                                                            } else {
                                                                setSingleDate(null);
                                                            }
                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                        style={{ width: "200px" }}
                                                    />
                                                )}
                                            </Box>
                                        </Box>
                                        <Box
                                            sx={{
                                                mt: 3,
                                                display: "flex",
                                                gap: 2,
                                                justifyContent: "flex-start",
                                            }}
                                        >
                                            <Button
                                                variant="contained"
                                                onClick={handleSearch}
                                                disabled={
                                                    (dateMode === 'week' && (!dateRange.start || !dateRange.end)) ||
                                                    (dateMode === 'day' && !singleDate) ||
                                                    isLoading
                                                }
                                            >
                                                {isLoading ? "Generating..." : "Generate Report"}
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                onClick={handleDownload}
                                                disabled={summaryData.length === 0 || isLoading || isDownloading}
                                            >
                                                {isDownloading ? (<CircularProgress size={24} />) : "Download PDF"}
                                            </Button>
                                        </Box>
                                    </Box>

                                    {/* --- Results Table --- */}
                                    {isSearched && (
                                        <Box sx={{ p: 2 }}>
                                            {isLoading ? (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        my: 4,
                                                    }}
                                                >
                                                    <CircularProgress />
                                                </Box>
                                            ) : summaryData.length > 0 ? (
                                                <Table bordered responsive hover>
                                                    <thead>
                                                        <tr>
                                                            {tableHeaders.map((header) => (
                                                                <th key={header}>{header}</th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {summaryData.map((row, index) => (
                                                            <tr key={index}>
                                                                {tableHeaders.map((header) => {
                                                                    const isNumeric = numericHeaders.includes(header);
                                                                    let cellValue = row[header];

                                                                    // ✅ Format specific date columns to mm/dd/yyyy
                                                                    if (
                                                                        header === "StartDate" ||
                                                                        header === "EndDate" ||
                                                                        header === "RequestDay" ||
                                                                        header === "WeekStartDate" ||
                                                                        header === "WeekEndDate"
                                                                    ) {
                                                                        cellValue = formatDate(cellValue);
                                                                    }

                                                                    if (isNumeric) {
                                                                        if (header === "WeeklyVOERequests" || header === "DailyVOERequests") {
                                                                            cellValue = parseInt(cellValue) || 0;
                                                                        } else {
                                                                            cellValue = formatNumber(cellValue);
                                                                        }
                                                                    }

                                                                    return (
                                                                        <td
                                                                            key={`${index}-${header}`}
                                                                            style={{
                                                                                textAlign: isNumeric ? "right" : "left",
                                                                                cursor: (header === "WeeklyVOERequests" || header === "DailyVOERequests") ? "pointer" : "default",
                                                                                color: (header === "WeeklyVOERequests" || header === "DailyVOERequests") ? "#1976d2" : "inherit",
                                                                                textDecoration: (header === "WeeklyVOERequests" || header === "DailyVOERequests") ? "underline" : "none",
                                                                            }}
                                                                            onClick={() => (header === "WeeklyVOERequests" || header === "DailyVOERequests") && handleCountClick(row)}
                                                                        >
                                                                            {cellValue}
                                                                        </td>
                                                                    );
                                                                })}

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            ) : (
                                                <Typography sx={{ textAlign: "center", my: 4 }}>
                                                    No data found for the selected criteria.
                                                </Typography>
                                            )}
                                        </Box>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    {/* VOE Detail Modal */}
                    <Dialog open={showDetailModal} onClose={() => setShowDetailModal(false)} maxWidth="md" fullWidth>
                        <DialogTitle>VOE Requesters</DialogTitle>
                        <DialogContent>
                            {isDetailLoading ? (
                                <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
                                    <CircularProgress />
                                </Box>
                            ) : detailData.length > 0 ? (
                                <Table bordered responsive hover>
                                    <thead>
                                        <tr>
                                            <th>Sr No.</th>
                                            <th>Employee Name</th>
                                            <th>Employee ID</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {detailData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.EmployeeName}</td>
                                                <td>{item.EmployeeID}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <Typography>No VOE requesters found for this period.</Typography>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setShowDetailModal(false)}>Close</Button>
                        </DialogActions>
                    </Dialog>
                </Container>
            </Fragment>
        </ErrorBoundary>
    );
};

export default VoeReport;